var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrongCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9365 1.30877L9.48449 0.0687321C9.43953 0.0286384 9.38399 0 9.32051 0C9.25703 0 9.19885 0.0286384 9.15388 0.0715959L3.87208 7.4202C3.87208 7.4202 1.79586 5.25801 1.73768 5.195C1.67949 5.132 1.60279 5.02603 1.48642 5.02603C1.37004 5.02603 1.31714 5.11481 1.25631 5.18068C1.21135 5.23223 0.470786 6.0742 0.105795 6.49232C0.0846357 6.51809 0.0714114 6.53241 0.0528973 6.55246C0.0211589 6.60115 0 6.65556 0 6.7157C0 6.7787 0.0211589 6.83025 0.0528973 6.87894L0.126954 6.9534C0.126954 6.9534 3.81125 10.7852 3.87208 10.8511C3.93292 10.9169 4.00697 11 4.11541 11C4.22121 11 4.30849 10.8769 4.35874 10.8224L10.9471 1.65816C10.9788 1.60948 11 1.55506 11 1.49206C11 1.42046 10.9736 1.36032 10.9365 1.30877Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongCheckIcon);
export default __webpack_public_path__ + "static/media/strong-check-icon.d2fd38b8b527398153d110c919c14d94.svg";
export { ForwardRef as ReactComponent };